import { useTexts } from '@shared/translation';
import { dateRangeTexts } from './texts';

interface Texts {
  shared: {
    ui: {
      daterange: typeof dateRangeTexts;
    };
  };
}

export function useDateRangeTexts() {
  return useTexts<Texts>().shared.ui.daterange;
}
